/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */

export type AgendaGenerationTranscriptionMetadataPurpose =
	(typeof AgendaGenerationTranscriptionMetadataPurpose)[keyof typeof AgendaGenerationTranscriptionMetadataPurpose];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgendaGenerationTranscriptionMetadataPurpose = {
	agendagenerate: 'agenda.generate',
} as const;
